import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAllProducts } from '../utils/shopify';

const ProductContext = createContext();

export function ProductContextProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const productsData = await getAllProducts();
        //console.log('Products Data:', productsData);

        if (Array.isArray(productsData)) {
          const processedProducts = productsData.map(node => ({
            ...node,
            images: node.images?.edges?.map(({ node: imageNode }) => imageNode) || [],
            variants: node.variants?.edges?.map(({ node: variantNode }) => variantNode) || []
          }));
          // console.log('Processed products:', processedProducts);
          setProducts(processedProducts);
        } else {
          // console.log('Invalid products data:', productsData);
          setProducts([]);
        }

        // Collections handling might need to be moved to a separate fetch
        // since getAllProducts no longer returns collections data

      } catch (err) {
        //console.error('Error fetching data:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const getProductsByCollection = (collectionId) => {
    const collection = collections.find(col => col.id === collectionId);
    return collection ? collection.products : [];
  };

  const getFeaturedProducts = () => {
    return products.filter(product => product.images && product.images.length > 0);
  };

  return (
    <ProductContext.Provider
      value={{
        products,
        collections,
        getProductsByCollection,
        getFeaturedProducts,
        loading,
        error,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}

export function useProducts() {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error('useProducts must be used within a ProductContextProvider');
  }
  return context;
}

export default ProductContext;
